import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Trans, useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'
import { RootState } from '../../store/rootReducer'

import usePageLoaded from '../../hooks/usePageLoaded'

import Title from '../../components/ui/title/title'

import { Helmet } from 'react-helmet'
import { META } from '../../constants/meta'

import { switchMenu } from '../../store/common/commonSlice'
import { getLangFromPath } from '../../i18next'
import './stub.sass'
import { createLocalizedPath } from '../../utils/localizationHelpers'

const Stub = () => {
    usePageLoaded()

    const [t] = useTranslation()
    const dispatch = useDispatch()
    const location = useLocation()
    const history = useHistory()

    const loggedIn = useSelector((state: RootState) => state.member.loggedIn)
    const [isPageLoaded, setIsPageLoaded] = useState(false)

    let menu: Element

    const switchMenuHandler = () => dispatch(switchMenu())

    useEffect(() => {
        setIsPageLoaded(true)
        menu = document.getElementsByClassName('menuButton')[0]
        if (menu) menu.classList.add('blink')
        return () => {
            if (menu) menu.classList.remove('blink')
        }
    }, [])

    const returnUrl = new URLSearchParams(location.search).get('returnPath')

    useEffect(() => {
        if (loggedIn && isPageLoaded) history.replace({ pathname: createLocalizedPath(returnUrl) })
    }, [loggedIn])

    return (
        <div className="pageContent" style={{ margin: '0 auto', maxWidth: '1360px', padding: '90px 27px' }}>
            <Helmet>
                <title>{META.stub[getLangFromPath(location.pathname)].title}</title>
                <meta name="description" content={META.stub[getLangFromPath(location.pathname)].description} />
            </Helmet>
            <Title text={t('Authorization required')} />
            <div className="loginRequestWrapper">
                <div className="loginRequest">
                    <img src={require('../../assets/ic-not-allowed.svg')} />
                    <p>{t('Only registered users have access to this page')}</p>
                    <p>
                        <Trans i18nKey={'Please login to open this page'}>
                            Please <span onClick={switchMenuHandler}>login</span> to open this page
                        </Trans>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Stub
